export default "__VITE_ASSET__CtRYjJ$z__"